import { motion } from "framer-motion";
import { CheckCircle2, Package } from "lucide-react";

const EASE = [0.16, 1, 0.3, 1];

const rows = [
  { label: "Delay detected", time: "14:02" },
  { label: "Customer notified", time: "14:02" },
  { label: "Carrier claim filed", time: "14:03" },
];

export const ExceptionCard = () => (
  <div
    data-testid="hero-exception-card"
    className="relative w-full max-w-sm rounded-3xl border border-edge/80 bg-[#0D1226]/90 p-6 shadow-[0_40px_80px_rgba(0,0,0,0.45)] backdrop-blur sm:p-7"
  >
    <div className="mb-5 flex items-start justify-between">
      <p className="font-mono text-xs font-medium uppercase tracking-[0.28em] text-mint">
        Exception resolved
      </p>
      <Package className="h-5 w-5 text-mint/80" strokeWidth={1.6} />
    </div>

    <p className="mb-6 font-mono text-sm tracking-[0.12em] text-slate-300">
      PKG #8421 <span className="text-mint">→</span> CHICAGO, IL
    </p>

    <div className="space-y-4">
      {rows.map((r, i) => (
        <motion.div
          key={r.label}
          initial={{ opacity: 0, x: -14 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.6, ease: EASE, delay: 1.7 + i * 0.28 }}
          className="flex items-center justify-between"
          data-testid={`exception-row-${i}`}
        >
          <span className="flex items-center gap-2.5 text-sm text-slate-100 sm:text-base">
            <CheckCircle2 className="h-5 w-5 text-mint" strokeWidth={1.8} />
            {r.label}
          </span>
          <span className="font-mono text-xs text-slate-500">{r.time}</span>
        </motion.div>
      ))}
    </div>

    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.8, delay: 2.7 }}
      className="mt-6 flex items-center justify-between border-t border-edge/70 pt-5"
    >
      <span className="text-sm text-slate-400 sm:text-base">Tickets opened</span>
      <span className="font-display text-xl font-bold text-mint">0</span>
    </motion.div>
  </div>
);
